module.exports = __webpack_public_path__ + "img/footer_06_kosme.33bddd0a.png";